import React from 'react'

import { Helmet } from 'react-helmet'

import Sidebar from '../components/sidebar'
import './support.css'

const Support = (props) => {
  return (
    <div className="support-container">
      <Helmet>
        <title>support - wapi</title>
        <meta property="og:title" content="support - wapi" />
      </Helmet>
      <div className="support-container1">
        <Sidebar rootClassName="sidebar-root-class-name2"></Sidebar>
        <div className="support-container2">
          <div className="support-header">
            <div className="support-container3">
              <div className="support-container4">
                <h3>Support</h3>
              </div>
            </div>
          </div>
          <div className="support-body">
            <div className="support-container5">
              <div className="support-container6">
                <span className="support-text1">
                  Free free to reach us via email
                </span>
                <a
                  href="mailto:admin@steksolutions.net?subject=Reaching Out"
                  className="support-link"
                >
                  admin@steksolutions.net
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Support
